import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {Icon} from '@stubhub/bamboo';
import FeatureToggle from '@stubhub/react-feature-toggle';
import FormattedLink from '@stubhub/react-formatted-link';

import {SAUDI_ARABIA_PDF_LINK, common_globalfooter_copyright_data} from './constants';
import FooterSocial from './footer-social';
import messages from './messages';

const UserAgreementLink = (chunks) => <FormattedLink href="/legal/?section=ua">{chunks}</FormattedLink>;
const PrivacyNoticeLink = (chunks) => <FormattedLink href="/legal/?section=pp">{chunks}</FormattedLink>;
const CookieNoticeLink = (chunks) => <FormattedLink href="/legal/?section=cn">{chunks}</FormattedLink>;

const FooterBottom = ({storeId, showSaudiArabiaVAT}) => {
  const now = new Date();
  const showCopyrightExtraInfo = common_globalfooter_copyright_data && !!common_globalfooter_copyright_data[storeId];

  const linkFirst = (
    <FormattedMessage
      {...messages['copyright-link-first']}
      values={{
        uaLink: UserAgreementLink,
        pnLink: PrivacyNoticeLink,
        cnLink: CookieNoticeLink,
      }}
    />
  );

  const linkSecond = (
    <FormattedLink href="/notifications/" className="copyright-policies">
      <FormattedMessage {...messages['copyright-link-second']} />
    </FormattedLink>
  );

  const copyright = (
    <span className="copyright-content">
      <FormattedMessage
        className="copyright-content"
        {...messages.copyright}
        values={{
          year: now.getUTCFullYear(),
          linkFirst,
          linkSecond,
        }}
      />
      <FeatureToggle name="common.footer.legal.extraInfo">
        {showCopyrightExtraInfo && (
          <span className="copyright-content copyright-content-extra" data-testid="copyright-content-extra">
            {' '}
            - {common_globalfooter_copyright_data[storeId]}
          </span>
        )}
      </FeatureToggle>
    </span>
  );

  return (
    <div className="footer-bottom" data-testid="footer-bottom">
      <div className="copyright-container">
        {copyright}
        {showSaudiArabiaVAT ? (
          <FormattedLink href={SAUDI_ARABIA_PDF_LINK} externalLink target="_blank" data-testid="SaudiArabiaVatLogo">
            <Icon name="SaudiArabiaVAT" className="footer-bottom__logo" />
          </FormattedLink>
        ) : null}
      </div>
      <FooterSocial />
    </div>
  );
};

FooterBottom.propTypes = {
  /** The SH store ID */
  storeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Whether we should show the Saudi Arabia VAT logo */
  showSaudiArabiaVAT: PropTypes.bool,
};

export default FooterBottom;
